module.exports = "https://www.gc-qa.gnp.com.mx/8454449008c987c76e8e9c68773455ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/descargar-movil.svg
// module id = 1818
// module chunks = 0